import { gql } from "@apollo/client";

export const GET_BREADCRUMB = gql`
    query Breadcrumb($input: QueryBreadcrumbInput!) {
        breadcrumb(input: $input)
    }
`;